<template>
  <h2 class="page_title ab">{{ title }}</h2>
</template>

<script>
export default {
  props: ['title']
}
</script>

<style lang="css" scoped>
.page_title {
  border-left: 4px solid  #4FCCD4;
  padding-left: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/PageTitle.vue